import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styles from './RightSlider.module.scss';
import modalExit from '../../../assets/icons/vector/exitModalIcon.svg';
import { useBrandingContext } from 'app-context/BrandingsContext';

const RightSlider = ({
  action,
  children,
  icon,
  title,
  actionButtons,
  className,
  titleClassName,
  contentClassName,
  subHeaderClassName,
  fullScreen = false,
  badge,
  isBackdrop = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [shouldRenderContent, setShouldRenderContent] = useState(false);
  const { brandingData } = useBrandingContext();
  const { page_TextColor } = brandingData;

  const toggleMenu = () => {
    if (action) {
      action.setIsOpen(!action.isOpen);
    } else {
      setIsOpen(!isOpen);
    }
  };

  const isMenuOpen = action?.isOpen || isOpen;

  useEffect(() => {
    let timeout;

    if (isMenuOpen) {
      setShouldRenderContent(true);
    } else {
      timeout = setTimeout(() => {
        setShouldRenderContent(false);
      }, 3000);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [isMenuOpen]);

  const shouldShowBackdrop = isBackdrop && !fullScreen;

  const modalContent = (
    <>
      {shouldShowBackdrop && (
        <div
          className={`${styles.backdrop} ${isMenuOpen ? styles.open : ''}`}
          onClick={toggleMenu}
          style={{
            color: page_TextColor,
          }}
        ></div>
      )}

      <div
        className={`${styles['menu-container']} ${
          isMenuOpen ? styles.open : ''
        } ${fullScreen ? styles.fullScreen : styles.normal} ${className || ''}`}
        style={{
          color: page_TextColor,
        }}
      >
        {shouldRenderContent ? (
          <>
            <div className={styles.header}>
              <div
                className={`${styles.subheader} ${subHeaderClassName || ''}`}
              >
                <div className={styles['title-wrapper']}>
                  <h3 className={titleClassName}>{title}</h3>

                  {badge !== undefined && badge !== null && (
                    <span className={styles.badge}>
                      <span className={styles['badge-text']}>{badge}</span>
                    </span>
                  )}
                </div>
                <div className={styles['actions-container']}>
                  {actionButtons}
                  <img src={modalExit} alt='Close' onClick={toggleMenu} />
                </div>
              </div>
            </div>

            <div className={`${styles.content} ${contentClassName || ''}`}>
              {children}
            </div>
          </>
        ) : null}
      </div>
    </>
  );

  return (
    <>
      {!action && (
        <div className={styles['menu-button']} onClick={toggleMenu}>
          <img src={icon} alt='icon' className={styles['burger-icon']} />
        </div>
      )}

      {ReactDOM.createPortal(modalContent, document.body)}
    </>
  );
};

export default RightSlider;
